module.exports = __webpack_public_path__ + "img/icon_menu_certificacion_discipline_hover.f49729d7.svg";